export enum IframeMessageType {
  ESCALATION_COMPLETED = 'ESCALATION_COMPLETED',
  ENROLLMENT_COMPLETED = 'ENROLLMENT_COMPLETED',
}
